<template>
  <router-link
    v-slot="{ href, isActive, navigate }"
    :to="to"
    custom
    active-class="active"
  >
    <li :class="{ active: isActive }">
      <a
        :href="href"
        class="button clear menu-item text-truncate"
        :class="{ 'is-active': isActive, 'text-truncate': shouldTruncate, 'show-account': showAccountLabel }"
        @click="navigate"
      >
        <span
          v-if="icon && fetchColorForConnected"
          :style="{ background: backgroundIconColor }"
          class="badge--icon"
        >
          <fluent-icon
            :style="{ color: letterIconColor }"
            class="inbox-icon"
            :icon="icon"
            size="12"
          />
        </span>
        <span
          v-if="labelColor"
          class="badge--label"
          :style="{ backgroundColor: labelColor }"
        />
        <span :title="menuTitle" class="menu-label button__content">
          <span class="menu-item-label">
            <span
              class="menu-item-label-text"
              :class="{
                'text-truncate': shouldTruncate,
                'text-bold': to.includes('/inbox'),
              }"
            >
              {{ labelFormatted }}
            </span>
            <span
              v-if="showAccountLabel"
              :class="{ 'text-truncate': shouldTruncate }"
            >
              {{ accountNameFormatted }}
            </span>
          </span>
          <span v-if="showChildCount" class="count-view">
            {{ childItemCount }}
          </span>
        </span>
        <span v-if="count" class="badge" :class="{ secondary: !isActive }">
          {{ count }}
        </span>
        <span v-if="warningIcon" class="badge--icon">
          <fluent-icon
            v-tooltip.top-end="$t('SIDEBAR.FACEBOOK_REAUTHORIZE')"
            class="inbox-icon"
            :icon="warningIcon"
            size="12"
          />
        </span>
      </a>
    </li>
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    accountName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    labelColor: {
      type: String,
      default: '',
    },
    shouldTruncate: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    warningIcon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    showChildCount: {
      type: Boolean,
      default: false,
    },
    childItemCount: {
      type: Number,
      default: 0,
    },
    inboxConnected: {
      type: Boolean,
      default: false,
    },
    isWhatsapp: {
      type: Boolean,
      default: false,
    },
    showAccountLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backgroundIconColor: '',
      letterIconColor: '',
    };
  },
  computed: {
    showIcon() {
      return { 'text-truncate': this.shouldTruncate };
    },
    menuTitle() {
      return this.shouldTruncate ? this.label : '';
    },
    fetchColorForConnected() {
      if (this.inboxConnected && this.isWhatsapp) {
        (this.backgroundIconColor = '#00DCB784'),
          (this.letterIconColor = '#009B5C');
      } else if (!this.inboxConnected && this.isWhatsapp) {
        this.backgroundIconColor = '#F69898';
        this.letterIconColor = '#DE1E27';
      }
      return true;
    },
    labelFormatted() {
      return this.label
        ? this.label.toLowerCase().replace(/\b\w/g, char => {
            if (this.to.includes('/inbox')) {
              return char.toUpperCase();
            }
            return char;
          })
        : '';
    },
    accountNameFormatted() {
      return this.accountName
        ? this.accountName.toLowerCase().replace(/\b\w/g, char => {
            if (this.to.includes('/inbox')) {
              return char.toUpperCase();
            }
            return char;
          })
        : '';
    },
  },
};
</script>
<style lang="scss" scoped>
$badge-size: var(--space-normal);
$label-badge-size: var(--space-slab);

.button {
  margin: var(--space-small) 0;
}

.text-bold {
  font-weight: var(--font-weight-bold);
}

.menu-item {
  display: inline-flex;
  color: var(--s-600) !important;
  width: 100%;
  font-weight: var(--font-weight-normal);
  padding: 2px;
  margin: 0;
  height: 2em;
  align-items: center;
  text-align: left;
  line-height: 1.6;

  &:hover {
    background: var(--s-50);
    color: var(--s-800);
  }

  &:focus {
    border-color: #e1f8fb;
  }

  // Ativo no padrão do protótipo: tint ciano + texto ciano-escuro
  &.is-active {
    background: #e1f8fb;
    color: #0a7581 !important;
    border-color: #e1f8fb;
  }
  &.is-active .count-view {
    background: transparent;
    color: #0a7581 !important;
  }
  &.show-account {
    height: fit-content;
  }
}

.menu-label {
  flex-grow: 1;
  display: flex;
  min-width: 0;
  align-items: center;
}

.menu-item-label {
  display: flex;
  min-width: 0;
  justify-content: center;
  flex-direction: column;
  font-size: var(--font-size-small);
  /* font-weight: var(--font-weight-bold); */
  line-height: var(--font-size-small);
}

.inbox-icon {
  font-size: var(--font-size-micro);
}

.badge--label,
.badge--icon {
  display: inline-flex;
  border-radius: var(--border-radius-small);
  margin-right: var(--space-smaller);
  background: var(--s-100);
}

.badge--icon {
  align-items: center;
  height: $badge-size;
  justify-content: center;
  min-width: $badge-size;
}

.badge--label {
  height: $label-badge-size;
  min-width: $label-badge-size;
  margin-left: var(--space-smaller);
  border: 1px solid var(--color-border-light);
}

.badge.secondary {
  min-width: unset;
  background: transparent;
  color: var(--s-400);
  font-weight: var(--font-weight-bold);
}

.menu-item-label-text {
  align-items: center;
  line-height: 1.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 5px;
}

.count-view {
  background: transparent;
  color: var(--s-400);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-bold);
  margin-left: var(--space-smaller);
  padding: 0 var(--space-micro);
  line-height: var(--font-size-small);
}
</style>
